<div class="mainWrapper">
  <div class="header">
    <div class="topWrapper">
      <h2>
        <a [routerLink]="['/model/list', _car?.carModel?.manufacturer?.id]"
          >{{ _car?.carModel?.manufacturer?.description }}
        </a>
        <a [routerLink]="['/modification/list', _car?.carModel?.id]">{{
          _car?.carModel?.description
        }}</a>
        {{ _car?.description }}
      </h2>
      <div class="linksWrapper">
        <a mat-button color="primary" [routerLink]="['/modification/profile', _car?.id, 'items']"
          >Товары</a
        >
        <a
          mat-flat-button
          color="primary"
          [routerLink]="['/modification/profile', _car?.id, 'info']"
          >Информация</a
        >
      </div>
    </div>
    <span> {{ getEngineDescription() }} {{ getHorsePower() }} </span>
  </div>
  <div class="bodyWrapper">
    <form (ngSubmit)="save()" [formGroup]="profileForm" class="drop-padding mainForm">
      <h3>Общая информация</h3>
      <mat-form-field appearance="outline">
        <mat-label>Название</mat-label>
        <input matInput type="text" formControlName="description" placeholder="Название" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Начало производства</mat-label>
        <input matInput [matDatepicker]="picker_from" formControlName="manufacture_date_from" />
        <mat-datepicker-toggle matSuffix [for]="picker_from"></mat-datepicker-toggle>
        <mat-datepicker #picker_from></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Конец производства</mat-label>
        <input matInput [matDatepicker]="picker_to" formControlName="manufacture_date_to" />
        <mat-datepicker-toggle matSuffix [for]="picker_to"></mat-datepicker-toggle>
        <mat-datepicker #picker_to></mat-datepicker>
      </mat-form-field>
      <app-engine-select [control]="enginesControl"></app-engine-select>
      <button mat-flat-button color="primary">Сохранить</button>
    </form>
    <div class="tableWrapper">
      <h3>Допольнительная информация</h3>
      <table mat-table [dataSource]="info" matSort (matSortChange)="sortData($event)">
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Наименование</th>
          <td mat-cell *matCellDef="let info">
            {{ info.description }}
          </td>
        </ng-container>
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Значение</th>
          <td mat-cell *matCellDef="let info">{{ info.value }}</td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>
            <button mat-icon-button (click)="addinfoRow()">
              <mat-icon>add</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let info">
            <div class="acitonWrapper">
              <button mat-icon-button color="primary" (click)="editInfoRow(info)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="confirmDialog(info)">
                <mat-icon>remove</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
      </table>
    </div>
  </div>
</div>
